import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { DirectionProvider, MantineProvider } from '@mantine/core'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import './index.css'

import App from './App'
import { theme } from './theme'

// One QueryClient for the app.
//
// `retry: false` on mutations is deliberate: a failed POST may well have
// reached the server, and silently repeating it could create a second dealer
// or a second issuance. Reads are safe to retry; writes are not.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* DirectionProvider is what makes Mantine's own components mirror.
        The <html dir="rtl"> in index.html handles the document; without this
        provider, Mantine's internal positioning (menus, popovers, drawers)
        still lays out left-to-right. Both are required. */}
    <DirectionProvider initialDirection="rtl">
      <MantineProvider theme={theme} defaultColorScheme="auto">
        <Notifications position="top-left" />
        {/* Destructive actions confirm through `components/confirm.tsx`, which
            needs this provider mounted above every screen that calls it. */}
        <ModalsProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </ModalsProvider>
      </MantineProvider>
    </DirectionProvider>
  </StrictMode>,
)
